import type { RequiredAccess } from "~domain/auth/models/access-model.ts";
import type { OperatorAccesses } from "~domain/operators/models/operator-model.ts";

export function hasAccess(permissions: OperatorAccesses, access: Partial<RequiredAccess>) {
  if (access.content) {
    if (!permissions.some((p) => p.content === access.content)) {
      console.error(`User has not the content permission ${access.content}`);
      return false;
    }
  }

  if (access.function) {
    if (!permissions.some((p) => p.function === access.function)) {
      console.error(`User has not the function permission ${access.function}`);
      return false;
    }
  }

  if (access.service) {
    if (!permissions.some((p) => p.service === access.service)) {
      console.error(`User has not the service permission ${access.service}`);
      return false;
    }
  }

  return true;
}
